import React from 'react'
import { webSocket } from './socket'

export var stationResponse, response;


export const sendFindStation = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'EntityRequest': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const findStation = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendFindStation(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendUpdateStationInformation = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'updateStationInformation': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const updateStationInformation = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendUpdateStationInformation(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendCreateDevice = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'createFirewall': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const createDevice = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendCreateDevice(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendDeleteDevice = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'deleteDevice': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const deleteDevice = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendDeleteDevice(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendCreateLocation = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'createLocation': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const createLocation = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendCreateLocation(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendDeleteVLAN = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'deleteVLAN': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const deleteVLAN = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendDeleteVLAN(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendUpdateVLAN = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'updateVLAN': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const updateVLAN = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendUpdateVLAN(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendSaveVLAN = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'saveVLAN': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const saveVLAN = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendSaveVLAN(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendSaveProfileSettings = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'saveProfileSettings': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const saveProfileSettings = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendSaveProfileSettings(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendUpdateSerialNumber = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'changeFirewallID': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const updateSerialNumber = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendUpdateSerialNumber(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}


export const sendSaveStation = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'saveEntry': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const saveStation = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendSaveStation(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendFindDevice = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({'findDevice': data}));
        stationResponse = resolve;
    })
    return promise;
}

export const findDevice = (data) => {
    const promise = new Promise(function(resolve, reject){
        sendFindDevice(data).then((response) => {
            resolve(response);
        })
    });
    return promise;
}

export const sendSaveAAPNetworkSettings = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'saveNetworkSettings': data}));
        stationResponse = resolve;
    });
    return promise;
}

export const saveAAPNetworkSettings = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendSaveAAPNetworkSettings(data).then(function(response){
            resolve(response);
        })
    });
    return promise;
}

export const sendGetDeviceEthers = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({'getEthers': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const getDeviceEthers = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendGetDeviceEthers(data).then(function(response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendSaveEthers = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({'saveEthers': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const saveEthers = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendSaveEthers(data).then(function(response) {
            resolve(response);
        })
    });
    return promise;
}


export const sendGetWinboxPath = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'requestPath': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const getPath = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendGetWinboxPath(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}


export const sendAdvancedFilter = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'advancedFilter': data }));
        stationResponse = resolve;
    });
    return promise;
}

export const advancedFilter = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendAdvancedFilter(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}



